var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4326_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4326_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99635 10.0167C7.91858 10.0167 7.84369 10.0027 7.77169 9.97467C7.69924 9.94711 7.63524 9.90556 7.57969 9.85L4.57969 6.85C4.47969 6.75 4.42969 6.63333 4.42969 6.5C4.42969 6.36667 4.47969 6.25 4.57969 6.15C4.67969 6.05 4.79635 6 4.92969 6C5.06302 6 5.17969 6.05 5.27969 6.15L7.99635 8.86667L10.713 6.15C10.813 6.05 10.9297 6 11.063 6C11.1964 6 11.313 6.05 11.413 6.15C11.513 6.25 11.563 6.36667 11.563 6.5C11.563 6.63333 11.513 6.75 11.413 6.85L8.41302 9.85C8.35747 9.90556 8.29369 9.94711 8.22169 9.97467C8.14924 10.0027 8.07413 10.0167 7.99635 10.0167Z",
    fill: "#81878C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.1bb6e51c4a3cb0484b828996e6b59b2a.svg";
export { ForwardRef as ReactComponent };